"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _command = require("@design/ui/command");
var _popover = require("@design/ui/popover");
var _portalLayer = require("@common/components/share/portal-layer");
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _categoryPaths = require("@common/utils/categoryPaths");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function CategoryDropdown(_ref) {
  var id = _ref.id,
    labelId = _ref.labelId,
    existingPaths = _ref.existingPaths,
    selectedPath = _ref.selectedPath,
    onSelectPath = _ref.onSelectPath,
    onOpenCreateModal = _ref.onOpenCreateModal;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    search = _useState4[0],
    setSearch = _useState4[1];
  var uniqueCategories = (0, _react.useMemo)(function () {
    return (0, _categoryPaths.getUniqueCategoryPathsWithPrefixes)(existingPaths);
  }, [existingPaths]);
  var trimmedSearch = search.trim();
  var filteredCategories = uniqueCategories.filter(function (cat) {
    return (0, _foldedTextSearch.matchesSearch)(cat, trimmedSearch);
  });
  var handleSelect = function handleSelect(path) {
    onSelectPath(path);
    setIsOpen(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_popover.Popover, {
    modal: true,
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      setIsOpen(open);
      setSearch("");
    },
    "data-sentry-element": "Popover",
    "data-sentry-component": "CategoryDropdown",
    "data-sentry-source-file": "CategoryDropdown.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverTrigger, {
      asChild: true,
      "data-sentry-element": "PopoverTrigger",
      "data-sentry-source-file": "CategoryDropdown.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
        id: id,
        "aria-labelledby": "".concat(labelId, " ").concat(id),
        variant: "outline",
        className: "w-full justify-between font-normal",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "CategoryDropdown.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: selectedPath ? undefined : "text-muted-foreground",
          children: selectedPath ? (0, _categoryPaths.formatCategoryPathForDisplay)(selectedPath) : "Select category"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
          "data-icon": "inline-end",
          "data-sentry-element": "KeyboardArrowDownIcon",
          "data-sentry-source-file": "CategoryDropdown.tsx"
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverContent, _objectSpread(_objectSpread({}, _portalLayer.PORTAL_LAYER_PROPS), {}, {
      align: "start",
      className: "w-(--radix-popover-trigger-width) p-0",
      "data-sentry-element": "PopoverContent",
      "data-sentry-source-file": "CategoryDropdown.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.Command, {
        shouldFilter: false,
        "data-sentry-element": "Command",
        "data-sentry-source-file": "CategoryDropdown.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandInput, {
          autoFocus: true,
          placeholder: "Search categories\u2026",
          value: search,
          onValueChange: setSearch,
          "data-sentry-element": "CommandInput",
          "data-sentry-source-file": "CategoryDropdown.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.CommandList, {
          "data-sentry-element": "CommandList",
          "data-sentry-source-file": "CategoryDropdown.tsx",
          children: [filteredCategories.map(function (path) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandItem, {
              value: path,
              "data-checked": selectedPath === path,
              onSelect: function onSelect() {
                return handleSelect(path);
              },
              children: (0, _categoryPaths.formatCategoryPathForDisplay)(path)
            }, path);
          }), trimmedSearch && !filteredCategories.some(function (c) {
            return (0, _foldedTextSearch.equalsFolded)(c, trimmedSearch);
          }) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.CommandItem, {
            value: "create:".concat(trimmedSearch),
            onSelect: function onSelect() {
              return handleSelect(trimmedSearch);
            },
            children: ["\"", trimmedSearch, "\" (create new)"]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandSeparator, {
            "data-sentry-element": "CommandSeparator",
            "data-sentry-source-file": "CategoryDropdown.tsx"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandGroup, {
            "data-sentry-element": "CommandGroup",
            "data-sentry-source-file": "CategoryDropdown.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.CommandItem, {
              value: "create-new-category",
              onSelect: function onSelect() {
                setIsOpen(false);
                onOpenCreateModal();
              },
              "data-sentry-element": "CommandItem",
              "data-sentry-source-file": "CategoryDropdown.tsx",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AddIcon, {
                "data-sentry-element": "AddIcon",
                "data-sentry-source-file": "CategoryDropdown.tsx"
              }), "Create new category"]
            })
          })]
        })]
      })
    }))]
  });
}
var _default = exports.default = CategoryDropdown;